import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';

import { DateAdapter } from '@angular/material/core';
import {
  NavigationHeaderComponent,
  headerItem,
} from '@standard-angular-utilities/shared-components';
import { UserService } from 'src/app/Services/user-service';
import equipmentRegistrationRouteConfig from './Routes';
import { SharedFunctionsService } from 'src/app/Services/sharedFunctions.service';
@Component({
  selector: 'equipment-base-root',
  templateUrl: './equipment-registration-base.component.html',
  styleUrl: './equipment-registration-base.component.css',
  imports: [RouterModule, RouterOutlet, NavigationHeaderComponent],
})
export class EquipmentRegistrationBaseComponent {
  showNavigation = true;
  get currentUser() {
    return this.userService.currentUser;
  }
  constructor(
    public userService: UserService,
    private sharedFunctionsService: SharedFunctionsService,
  ) {
    if (!this.currentUser) {
      this.userService.userStatusChanged$.subscribe((result) => {
        if (result) {
          this.addRoutes();
        }
      });
    } else {
      this.addRoutes();
    }
    const currentUrl = window.location.href; // Get the full URL
    if (currentUrl.includes("udstyr/KontrollerUdstyr")) {
      this.showNavigation = false;
    }
  }

  addRoutes() {
    if (!this.currentUser) {
      return;
    }

    this.userService.setRouteConfig(equipmentRegistrationRouteConfig);
  }
}
